/* gkg-visit.js — Verweildauer im Shop nach einem SMS-Link, Teil 2 (CRM, Denis 16.10.2026).
 *
 * Teil 1 (snippets/gkg-visit-boot.liquid, ganz oben im <head>) entscheidet, ob gemessen wird
 * (SMS-Code ?sk=/?pk= in der URL oder Besuch < 30 Min. her), meldet den Seitenaufruf sofort und
 * legt window.__gkgVisitBoot an. Ohne ihn passiert hier nichts — normale Besucher merken nichts.
 *
 * Aktive Zeit = Seite sichtbar UND der Kunde hat in den letzten 30 s gescrollt, getippt oder die
 * Maus bewegt. Beim Laden und bei der Rueckkehr in den Tab zaehlen ohne Eingabe hoechstens 15 s
 * (ein offen liegengelassenes Handy zaehlt nicht weiter). Nur das Scrollen der SEITE zaehlt —
 * automatisch laufende Slider (Info-Leiste) scrollen Elemente und sind keine Aktivitaet.
 * Meldung je Seitenaufruf (sid aus Teil 1) per sendBeacon an go.germany.kg/pk/<code>/e
 * (t = "visit"): alle 15 s bei Aenderung, beim Verlassen/Ausblenden und sofort bei
 * "In den Warenkorb" bzw. einem WhatsApp-Link. Werte sind je Seite kumuliert — verlorene
 * Meldungen schaden nicht, die naechste traegt den vollen Stand.
 * Ein Tab, der nach > 30 Min. ohne Aktivitaet wieder sichtbar wird, misst nicht weiter.
 */
(function () {
  'use strict';
  var b = window.__gkgVisitBoot;
  if (!b || b.skip || b.main) return;
  b.main = true;                                   // Teil 1 meldet ab jetzt nichts mehr selbst

  var KEY = 'gkg_sms_visit', SESSION = 30 * 60 * 1000, IDLE = 30 * 1000, GRACE = 15 * 1000,
      BEAT = 15000;
  var cfg = window.gkgVisit || {};
  var code = b.c, sid = b.sid, now0 = Date.now();

  function visible() { return document.visibilityState !== 'hidden'; }
  // bis hierher: Ladezeit (sichtbar, hoechstens GRACE) bzw. was Teil 1 beim Verlassen gemeldet hat
  var active = b.gone ? (b.ms || 0) : (visible() ? Math.min(Math.max(0, now0 - b.t0), GRACE) : 0);
  var lastTick = now0, lastInput = b.t0 - IDLE + GRACE, scroll = 0, cart = 0, wa = 0,
      sentKey = '', dead = false;

  function readSession() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  function save() {
    if (dead) return;
    try { localStorage.setItem(KEY, JSON.stringify({ c: code, t: Date.now() })); } catch (e) {}
  }
  function stillFresh() {                          // anderer Tab kann die Sitzung verlaengert haben
    var st = readSession();
    return !!(st && st.c === code && Date.now() - (+st.t || 0) < SESSION);
  }
  function tick() {
    var t = Date.now(), d = t - lastTick;
    lastTick = t;
    // Sprung nach Sperrbildschirm/Hintergrund: hoechstens 2 s je Schritt zaehlen
    if (!dead && d > 0 && visible() && t - lastInput < IDLE) active += Math.min(d, 2000);
  }
  function measureScroll() {
    var de = document.documentElement, bd = document.body;
    var h = Math.max(de ? de.scrollHeight : 0, bd ? bd.scrollHeight : 0);
    var y = (window.pageYOffset || (de && de.scrollTop) || 0) + (window.innerHeight || 0);
    if (h > 0) scroll = Math.max(scroll, Math.min(100, Math.round(100 * y / h)));
  }
  function send(force) {
    if (dead) return;
    tick();
    var key = Math.floor(active / 1000) + '|' + scroll + '|' + cart + '|' + wa;
    if (!force && key === sentKey) return;
    sentKey = key;
    var body = JSON.stringify({
      t: 'visit', sid: sid, ms: Math.round(active), sc: scroll, cart: cart, wa: wa,
      pt: String(cfg.t || b.pt || '').slice(0, 40), pid: +(cfg.p || b.pid) || 0,
      path: String(b.path || location.pathname || '').slice(0, 200)
    });
    var url = 'https://go.germany.kg/pk/' + code + '/e';
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }))) return;
    } catch (e) {}
    try {
      fetch(url, { method: 'POST', body: body, keepalive: true, mode: 'no-cors',
                   headers: { 'Content-Type': 'text/plain' } });
    } catch (e) {}
  }
  function onInput() {
    tick();
    lastInput = Date.now();
  }
  function isPageScroll(e) {
    var t = e && e.target;
    return t === document || t === window || t === document.documentElement || t === document.body;
  }
  function resume() {                              // Tab wieder sichtbar / aus dem Zurueck-Cache
    if (dead) return;
    if (!stillFresh()) { dead = true; return; }    // > 30 Min. ohne Aktivitaet: Besuch ist vorbei
    lastTick = Date.now();
    lastInput = lastTick - IDLE + GRACE;
  }

  ['touchstart', 'pointerdown', 'keydown', 'mousemove', 'wheel'].forEach(function (ev) {
    window.addEventListener(ev, onInput, { passive: true, capture: true });
  });
  window.addEventListener('scroll', function (e) {
    if (!isPageScroll(e)) return;                  // Element-Scroll (z. B. Auto-Slider) ist keine Eingabe
    onInput();
    measureScroll();
  }, { passive: true, capture: true });
  document.addEventListener('visibilitychange', function () {
    if (visible()) resume(); else send(true);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) resume(); });
  window.addEventListener('pagehide', function () { send(true); });
  // In den Warenkorb (Produktseite, Schnellkauf): das submit-Ereignis kommt auch, wenn
  // das Theme danach per fetch hinzufuegt
  document.addEventListener('submit', function (e) {
    var f = e.target, a = f && f.getAttribute ? (f.getAttribute('action') || '') : '';
    if (/\/cart\/add/.test(a)) { cart++; send(true); }
  }, true);
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest && e.target.closest('a[href*="wa.me"], a[href*="api.whatsapp.com"]');
    if (el) { wa++; send(true); }
  }, true);

  setInterval(tick, 1000);
  setInterval(function () {
    if (dead || !visible()) return;
    send(false);
    if (Date.now() - lastInput < IDLE) save();     // Besuch verlaengert sich nur bei Aktivitaet
  }, BEAT);
  measureScroll();
  send(true);
})();
